/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardFineListController {
   $log: any
   $scope: any
   alerts: any
   allSelected: any
   apiService: any
   docs: any
   emptyListMessage: any
   error: any
   i18n: any
   isLoading: any
   rawBibIds: any
   selectedCount: any
   sierraService: any
   total: any
   sierraFinePage: any
   libraryCardErrorHelper: any
   constructor($scope: any, sierraService: any, apiService: any, translationService: any, alertService: any, $log: any, $rootScope: any, $authEvents: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadFines = this.loadFines.bind(this)
      this.handleError = this.handleError.bind(this)
      this.updateSelected = this.updateSelected.bind(this)
      this.toggle = this.toggle.bind(this)
      this.getSierraFinePage = this.getSierraFinePage.bind(this)
      this.$scope = $scope
      this.sierraService = sierraService
      this.apiService = apiService
      this.$log = $log
      this.i18n = translationService
      this.isLoading = false
      this.docs = []
      this.rawBibIds = []
      this.selectedCount = 0
      this.allSelected = false
      this.alerts = alertService
      this.total = 0
      this.sierraFinePage = null
      this.libraryCardErrorHelper = libraryCardErrorHelper

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.docs = [])
   }

   $onInit() {
      this.loadFinesAndMoreDetailsLinkWhenReady()
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue) {
         return this.loadFinesAndMoreDetailsLinkWhenReady()
      }
   }

   loadFinesAndMoreDetailsLinkWhenReady(){
      this.isLoading = true
      return this.sierraService.patronInfoLoadedPromise.promise
         .then(() => {
            this.loadFines()
            this.getSierraFinePage()
         })
         .catch((err: any) => this.handleError(err))
   }

   loadFines() {
      this.isLoading = true
      return this.sierraService
         .getFines()
         .then((resp: any) => {
            this.rawBibIds = _.map(resp.data.entries, (fine: any) => ({
               // optional parameter, not always present
               bibId: fine.item ? fine.item.bibIds[0] : "",

               // optional parameter, not always present
               requestedOn: fine.assessedDate,

               // chargeType not always present
               chargeTypeDisplay: fine.chargeType ? fine.chargeType.display : '',

               charge: fine.itemCharge,
               processingFee: fine.processingFee,
               billingFee: fine.billingFee,
               paidAmount: fine.paidAmount,
               description: fine.description,
               location: fine.location.name
            }))
            const bibIdIsOptional = true
            const apiQuery = this.sierraService.createApiQuery(this.rawBibIds, bibIdIsOptional)

            if (apiQuery) {
               return this.apiService.get('search', apiQuery, {avoidUpdateFire: true})
            }
         }).then((resp: any) => {
            if (resp && resp.data) {
               return this.docs = _.map(this.rawBibIds, (sierraFineDoc: any) => {
                  let doc, hideThumbnail
                  if (sierraFineDoc.bibId) {
                     doc = this.sierraService.findDocIfExists(resp.data.documents, sierraFineDoc.bibId)
                     if (!doc) {
                        doc = this.sierraService.createDummyDoc(this.i18n.translations.NO_RESOURCE_FOUND)
                     }
                  } else {
                     doc = this.sierraService.createDummyDoc(sierraFineDoc.description || this.i18n.translations.FINE_NO_RESOURCE)
                     hideThumbnail = true
                  }
                  const {
                     requestedOn
                  } = sierraFineDoc
                  const {
                     chargeTypeDisplay
                  } = sierraFineDoc
                  const amountDue = (sierraFineDoc.charge + sierraFineDoc.processingFee + sierraFineDoc.billingFee) - sierraFineDoc.paidAmount
                  const location = sierraFineDoc.location
              

                  return { doc, requestedOn, chargeTypeDisplay, amountDue, hideThumbnail, location }
               })
            } else {
               if (this.rawBibIds.length) {
                  return this.docs = _.map(this.rawBibIds, (sierraFineDoc: any) => {
                     return {
                        doc : this.sierraService.createDummyDoc(sierraFineDoc.description || this.i18n.translations.FINE_NO_RESOURCE),
                        hideThumbnail : true,
                        requestedOn : sierraFineDoc.requestedOn,
                        chargeTypeDisplay : sierraFineDoc.chargeTypeDisplay,
                        amountDue : (sierraFineDoc.charge + sierraFineDoc.processingFee + sierraFineDoc.billingFee) - sierraFineDoc.paidAmount,
                        location : sierraFineDoc.location
                     }
                  })
               } else { 
                  return this.docs = []
               }
            }
         }) // no response

         .then(() => {
            if (this.docs.length === 0) {
               this.emptyListMessage = this.i18n.translations.FINES_EMPTY
            } else { 
               this.docs.forEach((doc: any) => this.total += doc.amountDue)
            }
            return this.isLoading = false
         }).catch((err: any) => {
            return this.handleError(err)
         })
   }

   handleError(err: any) {
      this.$log.error(err)
      this.isLoading = false
      const errorMessage = this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)
      this.error = this.i18n.translate(this.i18n.translations.FINE_ERROR, {error: errorMessage})
      return this.alerts.setAlert('libraryCardListLoadError', this.error)
   }

   updateSelected() {
      this.selectedCount = _.filter(this.docs, (doc: any) => doc.selected).length
      return this.allSelected = this.selectedCount === this.docs.length
   }

   toggle(doc: any) {
      _.each(this.docs, (doc: any) => { return doc.selected = this.allSelected })
      return this.updateSelected()
   }

   getSierraFinePage(){
      this.sierraFinePage = this.sierraService.getRedirectLinkToSierraFinePage()
   }
}

LibraryCardFineListController.$inject = ['$scope', 'sierraService', 'apiService', 'translationService', 'alertService', '$log', '$rootScope', '$authEvents', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardFineListController', LibraryCardFineListController)
